var DealDetail;
(function (DealDetail) {
    myonce('dealDetail', () => {
        const $dealContainer = document.querySelector('.deal-detail');
        if ($dealContainer) {
            const $containerSlide = $dealContainer.querySelector('.slide-container.deal');
            const $slide = $dealContainer.querySelector('.slide.type-3');
            const $carousel = $dealContainer.querySelector('.train-card');
            const $location = $dealContainer.querySelector('.locations');
            const $locPagingBtn = $dealContainer.querySelector('.page-locations');
            const $vcards = $location.querySelector('.vertical-cards');
            const $switchTargetCard = $location.querySelector('.is-switch-target');
            const $viewed = $location.querySelector('.viewed-label');
            let config;
            let ambits = item_deal.ambiti
                .map(item => {
                return item.id;
            })
                .join(',');
            function getDeals() {
                const data = config || retrieveConfig($dealContainer);
                const headers = data.config.headers || {};
                config = data;
                return Fetch(data.url + '/search', {
                    headers: {
                        ...headers,
                    },
                    data: {
                        ambits,
                        limit: 10,
                        sort: 'vistanaz'
                    },
                })
                    .then(deals => {
                    buildDeals(deals.convenzioni.filter(c => c.id !== item_deal.id) || []);
                })
                    .finally(() => {
                    $dealContainer
                        .querySelector('.container-train-card')
                        .removeAttribute('data-spinner');
                });
            }
            function buildDeals(deals) {
                deals.forEach(deal => {
                    let $nextDeal = $slide.cloneNode(true);
                    $nextDeal.id = deal.id;
                    $nextDeal.querySelector('.heading .title').innerHTML = deal.titolo;
                    $nextDeal.querySelector('.body .description').innerHTML = deal.desc_breve;
                    if (deal.valida_da || deal.valida_a) {
                        let dateFrom = deal.valida_da && `dal: <b>${new Date(deal.valida_da).toLocaleDateString()}</b>` || '';
                        let dateTo = deal.valida_a && `al: <b>${new Date(deal.valida_a).toLocaleDateString()}</b>` || '';
                        $nextDeal.querySelector('.body .due-date').innerHTML = `Valida ${dateFrom} ${dateTo}`;
                    }
                    $nextDeal.querySelector('.footer .info').innerHTML = 'PER I SOCI';
                    $nextDeal.querySelector('.footer .discount').innerHTML =
                        (deal.vantaggio && deal.vantaggio.vantaggio_applicato) || 'Vedi dettaglio';
                    const sedi = deal.sedi;
                    if (sedi) {
                        const $containerPosition = $nextDeal.querySelector('.body .container-position');
                        const $position = $containerPosition.querySelector('.position.dummy');
                        sedi.slice(0, 2).forEach(position => {
                            let $nextPosition = $position.cloneNode(true);
                            $nextPosition.querySelector('.text').innerHTML = `${position.denominazione_sede} - ${position.citta}`;
                            $nextPosition.classList.remove('dummy');
                            $containerPosition.appendChild($nextPosition);
                        });
                        if (sedi.length > 2) {
                            let $nextPosition = $position.cloneNode(true);
                            $nextPosition.querySelector('.text').innerHTML = `+ altri ${sedi.length - 2}`;
                            $nextPosition.classList.remove('dummy');
                            $containerPosition.appendChild($nextPosition);
                        }
                    }
                    $nextDeal.classList.remove('dummy');
                    $containerSlide.appendChild($nextDeal);
                    let url = '/vantaggi-e-servizi/convenzioni/' + deal.id + '/' + deal.titolo.replace(/[^a-zA-Z0-9\s\-_]/gmi, '').replace(/\s/gmi, '-');
                    $nextDeal.addEventListener('click', () => {
                        location.href = url;
                    });
                });
                trigger(document, 'init-train-card', $carousel);
            }
            function retrieveConfig($wrapper) {
                let data = {};
                const $form = $wrapper.querySelector('.ep-config');
                if ($form) {
                    try {
                        const url = $form.querySelector('[name="url"]').value;
                        const config = $form.querySelector('[name="config"]').value;
                        data = {
                            url,
                            config: JSON.parse(config),
                        };
                    }
                    catch (e) {
                        console.log('Error during retrieval of configuration for current service. %s', e);
                    }
                }
                return data;
            }
            function initPaging() {
                if ($location.querySelectorAll('.card.is-paged').length) {
                    $locPagingBtn.addEventListener('click', () => {
                        const $target = [].slice.call($location.querySelectorAll('.card:not(.is-paged)')).pop();
                        [].slice.call($location.querySelectorAll('.card.is-paged'), 0, 12)
                            .forEach((item) => {
                            item.classList.remove('is-paged');
                        });
                        if (!$location.querySelectorAll('.card.is-paged').length) {
                            $locPagingBtn.classList.add('hidden');
                        }
                        $viewed.innerHTML = `Hai visualizzato <b>${[].slice.call($location.querySelectorAll('.card:not(.is-paged)')).length}</b> di <b>${$location.querySelectorAll('.card').length}</b> sedi.`;
                        document.scrollingElement.scrollTo(0, $target.offsetTop);
                    });
                    $viewed.innerHTML = `Hai visualizzato <b>${[].slice.call($location.querySelectorAll('.card:not(.is-paged)')).length}</b> di <b>${$location.querySelectorAll('.card').length}</b> sedi.`;
                    $locPagingBtn.classList.remove('hidden');
                }
            }
            function orderLocations() {
                const $toOrder = $location.querySelector('.to-order');
                if ($toOrder) {
                    let $ordered = [];
                    getCoords()
                        .then((position) => {
                        const lat = position.coords.latitude;
                        const lon = position.coords.longitude;
                        $toOrder.querySelectorAll('.card').forEach(($card) => {
                            const $data = $card.querySelector('input.data');
                            const data = JSON.parse($data.value);
                            const distance = Math.abs(lat - data.latitudine) + Math.abs(lon - data.longitudine);
                            $card.distFactor = distance;
                            $card.classList.remove('is-paged');
                            let i = 0;
                            let len = $ordered.length;
                            while (i < len && distance > $ordered[i].distFactor) {
                                i++;
                            }
                            $ordered.splice(i, 0, $card);
                        });
                        $ordered.slice(12)
                            .forEach((item) => {
                            item.classList.add('is-paged');
                        });
                        $toOrder.innerHTML = '';
                        $ordered.forEach(($item) => {
                            $toOrder.appendChild($item);
                        });
                    });
                }
            }
            function init() {
                getDeals();
                if ($vcards) {
                    $vcards.querySelectorAll('.card').forEach(($card) => {
                        $card.addEventListener('click', () => {
                            const $data = $card.querySelector('input.data');
                            const data = JSON.parse($data.value);
                            const $phone = $switchTargetCard.querySelector('.phone');
                            const $email = $switchTargetCard.querySelector('.email');
                            const $image = $card.querySelector('.image img');
                            if (data) {
                                $vcards.querySelectorAll('.is-hidden').forEach(($item) => {
                                    $item.classList.remove('is-hidden');
                                });
                                $card.classList.add('is-hidden');
                                $vcards.appendChild($card);
                                if ($image.getAttribute('src')) {
                                    $switchTargetCard.querySelector('.image').classList.remove('hidden');
                                    $switchTargetCard.querySelector('img').src = $image.getAttribute('src');
                                }
                                else {
                                    $switchTargetCard.querySelector('.image').classList.add('hidden');
                                    $switchTargetCard.querySelector('img').setAttribute("src", "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==");
                                }
                                $switchTargetCard.querySelector('.title').innerHTML = data.denominazione_sede;
                                $switchTargetCard.querySelector('.address').innerHTML = `${data.indirizzo} <br> ${data.cap} ${data.citta}`;
                                if ($phone) {
                                    if (data.telefono) {
                                        $phone.classList.remove('hidden');
                                        $phone.innerHTML = data.telefono;
                                        $phone.setAttribute('href', `tel:${data.telefono}`);
                                    }
                                    else {
                                        $phone.classList.add('hidden');
                                    }
                                }
                                if ($email) {
                                    if (data.email) {
                                        $email.classList.remove('hidden');
                                        $email.innerHTML = data.email ? data.email : '';
                                        $email.setAttribute('href', `mailto:${data.email}`);
                                    }
                                    else {
                                        $email.classList.add('hidden');
                                    }
                                }
                                $switchTargetCard.querySelector('.description').innerHTML = data.vantaggio.desc_vantaggio_appl;
                                document.scrollingElement.scrollTo(0, $switchTargetCard.offsetTop - $switchTargetCard.offsetHeight);
                            }
                        });
                    });
                }
                orderLocations();
                initPaging();
                $dealContainer.querySelectorAll('[data-date-conversion]').forEach(($date) => {
                    const timestamp = +$date.getAttribute('data-date-conversion');
                    if (!isNaN(timestamp)) {
                        $date.innerHTML = new Date(timestamp).toLocaleDateString();
                    }
                });
            }
            init();
        }
    });
})(DealDetail || (DealDetail = {}));
